import React, { useState, useRef, useEffect } from "react"
import { useDispatch } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import { jwtDecode } from "jwt-decode"
import { toast } from "react-toastify"
import {
  Button,
  Card,
  CardBody,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalBody,
  ModalHeader
} from "reactstrap"
import NavbarSearch from "./NavbarSearch"
import { AlignLeft, Search, ChevronDown } from "react-feather"
import "../../styles/mixins/_navs.scss"
import "../../styles/avatar.scss"
import { isEmpty, isUserLoggedIn } from "../../utils/commonFunction"
import UserProfileTab from "./UserProfileTab"
import { logout } from "../../services/endpointUtils/auth"
import ThemeSwitch from "./ThemeSwitch"
function Navbar({ handleToggle, sidebarIsOpen }) {
  const navigate = useNavigate()
  const location = useLocation()

  const [openDropDown, setOpenDropDown] = useState(false)
  const [openSearchBar, setOpenSearchBar] = useState(false)
  const [userProfile, setUserProfile] = useState(false)
  const dropdownRef = useRef(null)

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropDown(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [dropdownRef])
  const token = localStorage.getItem("accessToken")

  if (isEmpty(isUserLoggedIn())) {
    navigate("/login")
  }

  let name = ""
  let role = ""

  const project = location.pathname.split("/")[3]
  try {
    if (token) {
      const userDetails = jwtDecode(token)
      name = userDetails?.userData?.name
      role = userDetails?.userData?.role
    }
  } catch (error) {
    toast("Failed to decode token or retrieve user details:", {
      hideProgressBar: true,
      type: error
    })
  }

  const handleDropDown = () => {
    setOpenDropDown(!openDropDown)
  }

  const userProfileModal = () => {
    setUserProfile(!userProfile)
    setOpenDropDown(false)
  }

  const onLogout = async () => {
    const refresh_key = localStorage.getItem("refreshToken")
    logout({ refresh: refresh_key })
      .then((response) => {
        if (response?.data?.responseCode === 202) {
          toast.success(`${response.data.data.result.results.message}`, { hideProgressBar: true })
        } else {
          toast.warning(`${response.data.error.detail}`)
        }
        localStorage.clear()
        window.location.href = '/login'
      })
      .catch((e) => {
        localStorage.clear()
        window.location.href = '/login'
      })
  }

  return (
    <>
      <nav
        className={`navbar border ${sidebarIsOpen
          ? "nav-width-colleps ml-80 br mt-0 mt-lg-3"
          : "nav-width ml-250 mt-0 mt-lg-3 br "
          }`}
      >
        {openSearchBar ? (
          <NavbarSearch setOpenSearchBar={setOpenSearchBar} openSearchBar={openSearchBar} />
        ) : (
          <div className='container-fluid'>
            <div className='menu-btn-container d-flex'>
              <button
                className='btn d-block d-lg-none'
                id='menu-btn'
                type='button'
                data-bs-toggle='offcanvas'
                data-bs-target='#drawer'
                aria-controls='drawer'
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                  stroke='currentColor'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  className='ficon'
                >
                  <line x1='3' y1='12' x2='21' y2='12'></line>
                  <line x1='3' y1='6' x2='21' y2='6'></line>
                  <line x1='3' y1='18' x2='21' y2='18'></line>
                </svg>
              </button>
              <div className='d-none d-lg-flex' onClick={() => handleToggle(!sidebarIsOpen)}>
                <Button color=' btn-outline-primary'>
                  <AlignLeft className='mr-25' size={14} />
                </Button>
              </div>
            </div>
            <ul className='navbar-nav d-flex flex-row align-items-center gap-1'>
              <li className='nav-item d-flex align-items-center'>
                <ThemeSwitch />
              </li>

              {project === "mdms" && (
                <Search onClick={() => setOpenSearchBar(true)} className="onIconHover mr_10" />
              )}

              <li className='dropdown-user nav-item dropdown' ref={dropdownRef}>
                <a
                  aria-haspopup='true'
                  className='nav-link dropdown-user-link pt-0 pb-0'
                  aria-expanded='false'
                >
                  <div className='d-flex align-items-center' onClick={handleDropDown} style={{ cursor: 'pointer', position: 'relative' }}>
                    <div
                      className="d-flex align-items-center justify-content-center rounded-circle text-white fw-bold"
                      style={{
                        width: '42px',
                        height: '42px',
                        backgroundColor: 'var(--navbar-avatar-bg)',
                        fontSize: '18px',
                        zIndex: 2,
                        position: 'relative',
                        boxShadow: 'var(--navbar-avatar-glow)'
                      }}
                    >
                      {name ? name.charAt(0).toUpperCase() : 'A'}
                    </div>

                    <div
                      className="d-flex align-items-center rounded-end"
                      style={{
                        backgroundColor: 'var(--navbar-chip-bg)',
                        height: '38px',
                        marginLeft: '-20px',
                        paddingLeft: '30px',
                        paddingRight: '15px',
                        zIndex: 1,
                        color: 'var(--navbar-chip-role)',
                        borderTopRightRadius: '25px',
                        borderBottomRightRadius: '25px'
                      }}
                    >
                      <div className="d-flex flex-column justify-content-center me-2" style={{ lineHeight: '1.2' }}>
                        <span
                          className="fw-bold"
                          style={{
                            color: 'var(--navbar-chip-name)',
                            fontSize: '14px',
                            letterSpacing: '0.3px'
                          }}
                        >
                          {name || "Avdhaan"}
                        </span>
                        <span
                          style={{
                            color: 'var(--navbar-chip-role)',
                            fontSize: '11px',
                            textTransform: 'capitalize'
                          }}
                        >
                          {role || "Admin"}
                        </span>
                      </div>

                      <ChevronDown size={18} color="currentColor" strokeWidth={2.5} />
                    </div>
                  </div>
                </a>

                {openDropDown && (
                  <Card
                    tabIndex='-1'
                    role='menu'
                    className='position-absolute end-0 mt-1 '
                    strokeWidth='2'
                    style={{
                      zIndex: "150"
                    }}
                  >
                    <CardBody className='p-0'>
                      <ListGroup>
                        <ListGroupItem
                          tag='button'
                          action
                          className='dropdown-item b-0'
                          onClick={userProfileModal}
                        >
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='14'
                            height='14'
                            viewBox='0 0 24 24'
                            fill='none'
                            stroke='currentColor'
                            strokeWidth='2'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            className='me-1'
                          >
                            <path d='M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2'></path>
                            <circle cx='12' cy='7' r='4'></circle>
                          </svg>
                          <span className='align-middle'>User Profile</span>
                        </ListGroupItem>
                        {role === "superadmin" && (
                          <ListGroupItem
                            tag='button'
                            action
                            className='dropdown-item b-0'
                            onClick={() => {
                              setOpenDropDown(false)
                              navigate("/admin")
                            }}
                          >
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              width='14'
                              height='14'
                              viewBox='0 0 24 24'
                              fill='none'
                              stroke='currentColor'
                              strokeWidth='2'
                              strokeLinecap='round'
                              strokeLinejoin='round'
                              className='me-1'
                            >
                              <circle cx='12' cy='12' r='3'></circle>
                              <path d='M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z'></path>
                            </svg>
                            <span className='align-middle'>Admin</span>
                          </ListGroupItem>
                        )}
                        {role === "superadmin" && (
                          <ListGroupItem
                            tag='button'
                            action
                            className='dropdown-item b-0'
                            onClick={() => {
                              setOpenDropDown(false)
                              navigate("/ssl-tracker")
                            }}
                          >
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              width='14'
                              height='14'
                              viewBox='0 0 24 24'
                              fill='none'
                              stroke='currentColor'
                              strokeWidth='2'
                              strokeLinecap='round'
                              strokeLinejoin='round'
                              className='me-1'
                            >
                              <path d='M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z'></path>
                            </svg>
                            <span className='align-middle'>SSL Tracker</span>
                          </ListGroupItem>
                        )}
                        <ListGroupItem
                          tag='button'
                          action
                          className='dropdown-item b-0'
                          onClick={onLogout}
                        >
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='14'
                            height='14'
                            viewBox='0 0 24 24'
                            fill='none'
                            stroke='currentColor'
                            strokeWidth='2'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            className='me-1'
                          >
                            <path d='M18.36 6.64a9 9 0 1 1-12.73 0'></path>
                            {/* <line x1='12' y1='2' x2='12' y2='12'></line> */}
                          </svg>
                          <span className='align-middle'>Logout</span>
                        </ListGroupItem>
                      </ListGroup>
                    </CardBody>
                  </Card>
                )}
              </li>
            </ul>
          </div>
        )}
      </nav>

      <Modal
        isOpen={userProfile}
        toggle={userProfileModal}
        className={`modal-md modal-dialog-centered`}
      >
        <ModalHeader className='model_header' toggle={userProfileModal}>
          User Profile
        </ModalHeader>
        <ModalBody className='p-4'>
          <UserProfileTab />
        </ModalBody>
      </Modal>
    </>
  )
}

export default Navbar
